import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode } from 'projects/core/src/include/structures';
import { Dossier, DossierField } from '../../../dossier';
import { DossierService } from '../../../services/dossier.service';
import { DossierPhasesService } from '../../../services/dossierphases.service';
import { DetailComponent } from './../detail/detail.component';
import { Globals } from 'projects/core/src/globals';
import { PreviewComponent } from './../preview/preview.component';
import { DossierOverviewsService } from '../../../services/dossieroverviews.service';
import { apply } from 'mathjs';
import { NotificationService } from 'projects/core/src/lib/notification.service';
import { Helper } from 'projects/core/src/helper';
import { formatDate } from '@angular/common';
import { ToastMode } from 'projects/core/src/include/structures';
import { NotesService } from 'projects/c1-backend/src/app/services/notes.service';

@Component({
  selector: 'app-dossierlistall',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.css']
})
export class AllListComponent extends ModelList<Dossier> implements OnInit {
  
  override modulename="dossier";
  
  tab=1;  
  filterTmp="";
  filterFieldValues=[];
  fields:DossierField[]=[];
  overviews=[];
  isFilterSet:boolean=false;

  @Input()
  id_address=0;

  @Input()
  filterbox:boolean=true;
  filterdate_param=99;

  get showHeaderTable(){

    if(this.module)
      return this.module.getParam("show_default_header_table",true);
    else
      return true;
  }

  get cols(){
    if(this.module)
      return this.module.getParam("cols_overview",3);
    else
      return 3;
  }

  constructor(
    private fb1: UntypedFormBuilder,
    private dossierService: DossierService,
    private dossierphasesService: DossierPhasesService,
    private dossierOverviewsService:DossierOverviewsService,
    private notificationService:NotificationService,
    private typesService:TypesService,
    private notesService:NotesService
  ) { 
    super(dossierService,fb1);
    this.detailViewModal=DetailComponent;
   
    
  }

  filter_id_address:Filter=new Filter();
  filter_search:Filter=new Filter();
  filter_status:Filter=new Filter();
  filter_id_type:Filter<number>=new Filter();
  filter_fieldvalue:Filter=new Filter();
  filter_date:Filter=new Filter();
  filter_fieldsearchable:Filter=new Filter();

  date_from: Date=new Date("2000-01-01");
  date_to: Date=new Date("2099-12-31");
  types=[];

  ngOnInit(): void {

    this.title = 'Pratiche';
    super.ngOnInit.apply(this);

    this.tab=this.module.getParam("default_dashboard_view","overview")=="overview"?1:2;

    
    this.typesService.getTypes("dossier").subscribe((result)=>{
      this.types=result;
    })
   
    
    this.afterGetItems=()=>{
      for(let i=0;i<this.list.length;i++){
        
        try{
          this.list[i]['errors']=JSON.parse(decodeURIComponent(this.list[i].errors));
        }catch{
          this.list[i]['errors']=[];
        }
      } 
    }

  }

  setFilters():void{

    this.filter_date.mode=FilterMode.date;
    this.filter_date.fields=[];
    this.filter_date.value=Helper.convertDateControl(this.date_from);
    this.filter_date.value2=Helper.convertDateControl(this.date_to);
    this.filter_date.fields.push("d.created");
    this.filter.push(this.filter_date);

   

    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("d.title");
    this.filter_search.fields.push("d.code");
    this.filter_search.fields.push("a.name");
    this.filter_search.fields.push("dfv.value");

    this.filter_search.value="";
    this.filter.push(this.filter_search);

    
    this.filter_fieldsearchable.mode=FilterMode.normal;
    this.filter_fieldsearchable.fields=[];
    this.filter_fieldsearchable.fields.push("df.searchable");
    this.filter_fieldsearchable.value="1";
    this.filter.push(this.filter_fieldsearchable);
    
    this.filter_id_type.mode=FilterMode.normal;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("d.id_type");
    this.filter_id_type.value=0;
    this.filter.push(this.filter_id_type);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("d.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.filter_id_address.mode=FilterMode.normal;
    this.filter_id_address.fields=[];
    this.filter_id_address.fields.push("d.id_address");
    this.filter_id_address.value="";
    this.filter.push(this.filter_id_address);

    //this.ordering.field="i.date DESC,CAST(i.reference AS UNSIGNED)";
    //this.ordering.mode=OrderingMode.discendent;    
    
    this.isFilterSet=true;
    
  }

  updateList():void{
    
    if(!this.isFilterSet)
        this.setFilters();

    if(this.id_address>0){
      this.filter_id_address.value=this.id_address.toString();
      this.paging_count=99999999;
      
    }
    this.getItems();
  }


  getParams(text){
    if(Array.isArray(text)){
      return text;
    }else{
      return JSON.parse(text);
    }
  }


  setFilterFieldValue(field,value){

    //trova il filtro
    let found=false;
    for(let f of this.filterFieldValues){
      if(f.field==field){
        f.value=value;
        found=true;
      }
    }

    if(!found){
      let f:any={};
      f.field=field;
      f.value=value;
      this.filterFieldValues.push(f);
    }

    let sql=[];
    for(let f of this.filterFieldValues){
      if(f.value!="")
        sql.push("dfv.id_field="+f.field.id+" AND dfv.value=\""+f.value+"\"")
    }

    if(sql.length>0){
      this.filter_fieldvalue.value=sql.join(" AND ");
    }else{
      this.filter_fieldvalue.value="";
    }
    
    this.getItems();
   
  }


  openPreview(record){
    console.log(record);
    Globals.modal.showModal(PreviewComponent,[
      {"name":"record","value":record}
    ],()=>{

    });
  }


  getOverviews(){
    this.dossierOverviewsService.getOverviews(0).subscribe((result)=>{
      this.overviews=result;
    })
  }


  getKeys(obj){
    if(obj)
      return Object.keys(obj);
    else
      return [];
  }


  notify(record:Dossier){  
      this.notificationService.showPreviewNotification(record.addressItem.contacts,record,"dossier",()=>{
  
      });      
    }
    


  getTitle(phase){
    switch(phase.state){
      case 1:
        return phase.title+" (in corso)";
      case 2:
        return phase.title+" (completata)";
      case 3:
        return phase.title+" (annullata)";   
      case 4:
        return phase.title+" (verificata)";   
      case 5:
        return phase.title+" (in attesa)";   
      case 6:
        return phase.title+" (archiviata)";   
      default:
        return phase.title+" (da avviare)";   
    }
  }


  getLastLog(record){
    if(record.log){
      if(record.log.length>0){
        return record.log[record.log.length-1];
      }
    }

    return null;

  }


  listNotes(notes){
    // raccoglie le note per il tooltip
    let result='';
    for(let n of notes){
      if(n.state==1){
        result = result + formatDate(n.date,'dd-MM-yyyy',"it-IT") + ' | ' + n.value + '\n';
      }        
    }
    if (result!='') result = result + '(Doppio Click per segnare come letto)';
    return result;

  }


  markNotes(notes){
    // segna tutte le note come lette
    for(let n of notes){
      n.state=2;        
    }

    this.notesService.saveMultiple(notes,()=>{
      Globals.message.showToaster("Tutte le note sono state segnate come lette",ToastMode.INFO);
      this.getItems();
    });
  }

}